<template lang="pug">
  .p-30
    .row.align-items-center.flex-sm-row-reverse.mb-3
      .col-lg-auto.ml-auto.mb-3.mb-lg-0.text-center
        el-button(type='primary' @click="dialog = true" v-if="checkAccess('addUser')") Add User
      // TODO put teams back
      .col-md-6.col-lg-4.mb-3.mb-md-0.d-none
        el-select(v-model="teamId" placeholder="Select").w-100
          el-option(label="All Teams" :value="null")
          el-option(
            v-for="item in teams" :key="item.id"
            :label="item.name" :value="item.id"
          )
      .col-md-6.col-lg-4
        el-input(
          v-model="searchInput"
          prefix-icon="el-icon-search"
          placeholder="Search by Name or Email..."
        )

    .card
      .card-body
        el-table(
          :data="filteredItems"
          v-loading="loading"
          @row-click="rowClicked"
          style="width: 100%"
        ).clickable-rows
          el-table-column(width="68")
            template(slot-scope="props")
              img(
                :src="props.row.imageUrl ? props.row.imageUrl : './assets/img/default-profile.jpg'"
              ).d-block.size-48.obj-f-c

          el-table-column(label="Name" min-width="180")
            template(slot-scope="props") {{ props.row.firstName }} {{ props.row.lastName }}

          // TODO Put teams back
          el-table-column(label="Team(s)" min-width="180")
            template(slot-scope="props")
              div(v-if="props.row.team.length && item.id" v-for="item in props.row.team"
              :key="item.team.id")
                div(
                  :style="{ backgroundColor: item.team.color }"
                ).size-12.rounded-circle.d-inline-block.mr-2
                | {{ item.team.name }}

          el-table-column(label="Email" prop="email" min-width="180")

          el-table-column(label="User Type" min-width="100")
            template(slot-scope="props") {{ showUserType(props.row) }}

          el-table-column(label="Status" align="center" width="100")
            template(slot-scope="props")
              template(v-if="props.row.isVerified")
                template(v-if="props.row.isActive")
                  el-tooltip(placement="top" content="Active").text-success
                    font-awesome-icon(:icon="['fal', 'check-circle']").size-26.d-block.mx-auto

                template(v-else)
                  el-tooltip(placement="top" content="Suspended").text-warning
                    font-awesome-icon(:icon="['fal', 'do-not-enter']").size-26.d-block.mx-auto

              template(v-else)
                el-tooltip(placement="top" content="Unverified").text-danger
                  font-awesome-icon(:icon="['fal', 'question-circle']").size-26.d-block.mx-auto

          el-table-column(width="46")
            .el-table__expand-icon
              i.el-icon.el-icon-arrow-right

    dialog-add-edit-user(
      v-if="dialog"
      :loading="loading"
      :dialog-visible.sync="dialog"
      :edited-item="editedItem"
      :form-title="formTitle"
      :teams="teams"
      :user-types="getUserTypes()"
      @save-user-item="saveUser"
      @delete-user-item="deleteUser"
      @close-dialog="closeDialog"
      @resend-verification="resendVerification"
    )
</template>

<script>

import uuid from 'uuid-v4';
import cleanDeep from 'clean-deep';
import { userTypes } from '@/data/lookups';
import { user as initUser, team as initTeam } from '@/data/init';
// import { team as initTeam } from '@/data/init';
// import { teams as dummyTeams } from '@/data/static';
import { mapGetters } from 'vuex';
import CrudDialogMixin from '@/mixins/crudDialogMixin';
import SubscribeMixin from '@/mixins/subscribeMixin';
import DialogAddEditUser from './DialogAddEditUser.vue';

import {
  getUserRecordsByCompany,
  getTeamRecordsByCompany,
  cognitoUserSignUp,
  createUserRecord,
  updateUserRecord,
  createTeamUserRecord,
  updateTeamUserRecord,
  cognitoVerificationMail,
} from '../../models/user';

export default {
  name: 'Users',
  components: { DialogAddEditUser },
  mixins: [CrudDialogMixin, SubscribeMixin],
  data() {
    return {
      searchInput: '',
      teamId: null,
      teams: [initTeam],
    };
  },
  computed: {
    ...mapGetters('users', ['me', 'isMeSignedIn', 'scopedCompany', 'isSuperAdmin']),
    filteredItems() {
      return this.getFilteredItems();
    },
    companyId() {
      if (this.scopedCompany) return this.scopedCompany.id;
      return null;
    },
  },
  watch: {
    me(val) {
      if (val) {
        this.init();
      }
    },
  },
  mounted() {
    if (this.companyId) {
      this.init();
    } else {
      this.$router.replace('/users');
    }
  },
  methods: {
    checkAccess(what) {
      if (!this.me || !this.me.userRecord) {
        return false;
      }
      const { userType } = this.me.userRecord;
      if (what === 'addUser') {
        if (userType.userType === 'SuperAdmin'
          || userType.userType === 'Admin') {
          return true;
        }
      }
      if (what === 'editUser') {
        if (userType.userType === 'SuperAdmin'
          || userType.userType === 'Admin') {
          return true;
        }
      }
      return false;
    },
    getUserTypes() {
      const types = JSON.parse(JSON.stringify(userTypes));
      const { userType } = this.me.userRecord;
      if (userType.userType !== 'SuperAdmin') {
        return types.filter((x) => x.id !== 'SuperAdmin');
      }
      return types;
    },
    init() {
      if (this.companyId) this.initData();
    },
    showUserType(obj) {
      return (obj && obj.userType) ? obj.userType.userType : '';
    },
    initData() {
      this.editedItem = JSON.parse(JSON.stringify(initUser));
      this.defaultItem = JSON.parse(JSON.stringify(initUser));
      this.getUserListItems();
      this.getTeamListItems();
      this.loading = false;
      this.loadingemail = false;
      this.subscribeToUserEvents();
    },

    getUserListItems() {
      getUserRecordsByCompany(this.companyId).then((res) => {
        this.items.length = 0;
        res.data.getUserByCompany.items.forEach((user) => {
          const teamData = [];
          if (user.team && user.team.items) {
            console.log(user);
            user.team.items.forEach((team) => {
              teamData.push(team);
            });
          }

          user.team = teamData;
          this.items.push(user);
        });
        console.log(this.items);
      });
    },

    getTeamListItems() {
      getTeamRecordsByCompany(this.companyId).then((res) => {
        this.teams.length = 0;
        res.data.getTeamByCompany.items.forEach((team) => {
          this.teams.push(team);
        });
      });
    },

    subscribeToUserEvents() {
      this.subscribeAndInvoke(
        [
          'onCreateUser',
          'onUpdateUser',
          'onDeleteUser',
        ],
        this.getUserListItems,
      );
    },
    getUserType(id) {
      return userTypes.find((obj) => obj.id === id).label;
    },

    async saveUser() {
      this.loading = true;
      if (this.editedItem.id) {
        // delete this.editedItem.teamsId;
        delete this.editedItem.teams;
        delete this.editedItem.email;
        delete this.editedItem.createdAt;
        delete this.editedItem.companyId;
        delete this.editedItem.company;
        await this.updateUser();
      } else {
        // delete this.editedItem.teamsId;
        delete this.editedItem.teams;
        this.editedItem.id = uuid();
        this.editedItem.companyId = this.companyId;
        await this.addUser();
      }
    },

    async addUser() {
      console.log('trying user signup');
      console.log(this.editedItem);
      this.loading = true;
      try {
        const cogUser = await cognitoUserSignUp(
          {
            email: this.editedItem.email,
            firstName: this.editedItem.firstName,
            lastName: this.editedItem.lastName,
          },
        );
        console.log(cogUser);
        const { teamsId } = this.editedItem;
        delete this.editedItem.teamsId;
        const userRecord = await createUserRecord(this.editedItem);
        console.log(userRecord);
        console.log('create user ', userRecord);

        const teamUserItem = {
          teamUserUserId: this.editedItem.id,
          teamUserTeamId: '',
        };
        teamsId.forEach((team) => {
          teamUserItem.id = uuid();
          teamUserItem.teamUserTeamId = team;
          const teamUserRecord = updateTeamUserRecord(teamUserItem);
          console.log(teamUserRecord);
        });
      } catch (err) {
        console.log('something went wrong while Signing up');
        console.log(err);
      } finally {
        this.closeDialog();
        this.loading = false;
      }
    },

    async updateUser() {
      console.log('trying updating user');
      this.loading = true;
      try {
        const { teamsId } = this.editedItem;
        delete this.editedItem.teamsId;
        const userRecord = await updateUserRecord(this.editedItem);
        console.log(userRecord);
        // const teamUserRecord = await updateTeamUserRecord(this.editedItem);
        // console.log('update user ', teamUserRecord);
        const teamUserItem = {
          teamUserUserId: this.editedItem.id,
          teamUserTeamId: '',
        };
        console.log(teamUserItem);
        console.log(teamsId);

        teamsId.forEach((team) => {
          teamUserItem.id = uuid();
          teamUserItem.teamUserTeamId = team;
          console.log(team);
          const updateteamUserRecord = createTeamUserRecord(teamUserItem);
          //    const updateteamUserRecord = updateTeamUserRecord(teamUserItem);
          console.log(updateteamUserRecord);
        });
      } catch (err) {
        console.log('something went wrong while updating');
        console.log(err);
      } finally {
        this.closeDialog();
        this.loading = false;
      }
    },

    rowClicked(row) {
      console.log('row clickes', row);
      if (this.checkAccess('editUser')) {
        this.editItem(row);
        console.log(row);
        if (!this.editedItem.userType) {
          this.editedItem.userType = { userType: null };
        }
      }
    },

    filterByInput(item) {
      return item.toLowerCase().includes(this.searchInput.toLowerCase());
    },

    filterById(item) {
      if (this.teamId === null) return true;
      return item.includes(this.teamId);
    },

    getFilteredItems() {
      const items = this.items.filter(
        (item) => (this.filterById(item.team)
          && (this.filterByInput(item.firstName)
            || this.filterByInput(item.lastName)
            || this.filterByInput(item.email))),
      );

      return items;
    },
    deleteUserItem(id) {
      return new Promise((resolve, reject) => {
        if (id && id !== '0') {
          // Note delete company user record to
          // User.deleteUserRecord({ id }).then(() => {
          //   resolve();
          // }).catch((e) => {
          //   console.log(e);
          //   reject(new Error(e));
          // });
          reject();
        } else {
          resolve();
        }
      });
    },
    deleteUser() {
      const userItem = cleanDeep(this.editedItem);
      const { id } = userItem;
      const that = this;
      this.$msgbox({
        title: 'Message',
        type: 'warning',
        message: 'This will permanently delete the record. Continue?',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = 'Deleting...';
            that.deleteUserItem(id).then(() => {
              instance.confirmButtonLoading = false;
            }).catch(() => {
              this.notifyMsg('error in deleting company');
            });
            instance.confirmButtonLoading = false;
            this.closeDialog();
            done();
          } else {
            done();
          }
        },
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed',
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelled',
        });
      });
    },
    async resendVerification() {
      const result = await cognitoVerificationMail(this.editedItem.email);
      console.log(result);
    },
  },
};
</script>
